<script setup lang="ts">
import type { PropertyAreaProps } from '.';
import type IntervalInput from '~/components/IntervalInput/Input.vue';

import { propertyAreaInputVariants } from '.';

const props = withDefaults(defineProps<PropertyAreaProps>(), {
	variant: 'primary'
});

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');

const intervalInputRef = ref<InstanceType<typeof IntervalInput> | null>(null);

defineExpose({
	focusFirstInputWhenReady: () =>
		intervalInputRef.value?.focusFirstInputWhenReady()
});
</script>

<template>
	<IntervalInput
		ref="intervalInputRef"
		v-model:min="min"
		v-model:max="max"
		title="Área útil"
		unit="area"
		min-label="Área mínima"
		max-label="Área máxima"
		update-on="blur"
		:variant="props.variant"
		:input-classes="propertyAreaInputVariants({ variant: props.variant })"
	/>
</template>
